module.exports = __webpack_public_path__ + "static/media/profileENSIcon.c17d584e.svg";